import { Box, Card, CardContent, CardMedia, Chip, Typography } from "@mui/material";

import { Tool } from "../../pages/Tools";

interface Props {
    onClick: (item: any) => void;
    items?: Tool[];
    selectedFilter: string;
}

const ModuleCard = ({
    onClick,
    items,
    selectedFilter
}: Props) => {

    return (
        <Box sx={{ 
            width: "100%", 
            display: "grid", 
            gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(auto-fill, minmax(380px, 1fr))"
            },
            gap: 4
        }}>
            {
                items?.filter(val => {
                    if (!val.permission) return false;
                    if (selectedFilter.toLowerCase() === "show all") return true;
                    return val.categories?.some(category =>
                        category.toLowerCase().includes(selectedFilter.toLowerCase())
                    );
                })
                    .map((item) => {

                        return (
                            <Card
                                sx={{
                                    borderRadius: "16px",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                    transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
                                    "&:hover": {
                                        cursor: "pointer"
                                    },
                                }}
                                onClick={() => onClick(item)}
                            >
                                {/* Card Media with Image */}
                                <Box sx={{ position: "relative" }}>
                                    {item.imageSrc ? (
                                        <CardMedia
                                            component="img"
                                            height="200"
                                            width="100%"
                                            image={item.imageSrc}
                                            alt={item.title}
                                            sx={{
                                                objectFit: "cover",
                                            }}
                                        />
                                    ) : (
                                        <Box
                                            sx={{
                                                height: "200px",
                                                backgroundColor: "#f5f5f5",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <Typography color="text.secondary">
                                                No Image Available
                                            </Typography>
                                        </Box>
                                    )}

                                    {/* Icon Overlay */}
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            bottom: -24,
                                            left: 16,
                                            backgroundColor: "#ff8c00",
                                            borderRadius: "12px",
                                            padding: "12px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                            zIndex: 1,
                                        }}
                                    >
                                        {item.icon}
                                    </Box>
                                </Box>

                                {/* Card Content */}
                                <CardContent sx={{ padding: "48px 24px 24px 24px" }}>
                                    {/* Title */}
                                    <Typography
                                        component="h2"
                                        sx={{
                                            fontWeight: 600,
                                            fontSize: "24px",
                                            marginBottom: "12px",
                                            color: "#333"
                                        }}
                                    >
                                        {item.title}
                                    </Typography>

                                    {/* Description */}
                                    <Typography
                                        sx={{
                                            color: "#666",
                                            lineHeight: 1.6,
                                            marginBottom: "20px",
                                            fontSize: "14px"
                                        }}
                                    >
                                        {item.description}
                                    </Typography>

                                    {
                                        item.categories?.map((category) => {
                                            return (
                                                <Chip
                                                    label={category}
                                                    sx={{
                                                        backgroundColor: "#e8f5e8",
                                                        color: "#2e7d32",
                                                        fontWeight: 500,
                                                        fontSize: "12px",
                                                        height: "32px",
                                                        borderRadius: "16px",
                                                        "& .MuiChip-label": {
                                                            padding: "0 12px"
                                                        }
                                                    }}
                                                />
                                            )
                                        })
                                    }

                                </CardContent>
                            </Card>

                        )
                    })
            }

        </Box>
    );
};

export default ModuleCard;